// Initialize Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyCwXElzujDFFqsV21kPZbZX-7rVrac_VTA',
  authDomain: 'flirts18com.firebaseapp.com',
  projectId: 'flirts18com',
  storageBucket: 'flirts18com.appspot.com',
  messagingSenderId: '802832152282',
  appId: '1:802832152282:web:bf1bfde0687334483217e3',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const pushMessaging = firebase.messaging();

//for foreground messages
pushMessaging.onMessage((payload) => {
  navigator
    .serviceWorker
    .getRegistration('/firebase-cloud-messaging-push-scope')
    .then(registration => {
      let notificationOptions = Object.assign({}, payload.data);
      notificationOptions.data = payload.data;

      registration.showNotification(
        (payload.data ? payload.data.title : ''),
        notificationOptions
      );
    });
});

export default pushMessaging;
